/** Foundation Geo Service — client (`/api/foundation/geo/*`). Unica fonte dati geografici della Suite. */
import { api } from "@/foundation/api/client";

export async function findComuni(q, { exact = false, limit = 10 } = {}) {
  const { data } = await api.get("/foundation/geo/comuni", { params: { q, exact, limit } });
  return data.items || [];
}
